import * as React from 'react';
import { Provider } from 'mobx-react';
import { configure } from 'mobx';
import { AppStore } from './stores';
import { App } from './App';
import { IInstance } from '../../interfaces/IInstance';

declare global {
  interface Window { webkit: any; app: any; android: WebAppInterface; platform: string }
  interface WebAppInterface { postMessage(message: string): any; }
}

export interface IAppProps {
  token: string;
  environment: "Development" | "Test" | "Production";
  tenant: string;
  preview?: boolean;
  instance?: IInstance;
  instances?: IInstance[];
  editMode?: boolean;
  selectedPageIndex?: number;
  previewSplashScreen?: boolean;
  switchApp?: () => void;
  logOut?: () => void;
  selectPage?: (index: number) => void;
}

export class IAApp extends React.Component<IAppProps> {

  private store: AppStore;

  constructor(props: IAppProps) {
    super(props);
    this.store = new AppStore();
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
    this.updateStore(props);
  }

  public componentWillReceiveProps(props: IAppProps) {
    this.updateStore(props);
  }

  private updateStore(props: IAppProps): void {
    this.store.token = props.token;
    this.store.tenant = props.tenant;
    this.store.environment = props.environment;
    this.store.preview = props.preview;
    this.store.instance = props.instance;
    this.store.editMode = props.editMode;
    if (props.preview) {
      this.store.isIPhoneXType = false;
    }
  }

  public render(): JSX.Element {
    return (
      <Provider store={this.store}>
        <App
          ref={(app: any) => {
            if (app) {
              window.app = app.wrappedInstance
            }
          }}
          instance={this.props.instance}
          editMode={this.props.editMode}
          previewSplashScreen={this.props.previewSplashScreen}
          selectedPageIndex={this.props.selectedPageIndex}
          switchApp={() => this.props.switchApp()}
          logOut={() => this.props.logOut()}
          selectPage={this.props.selectPage ? (index) => this.props.selectPage(index) : undefined}
        />
      </Provider>
    );
  }
}